import * as React from "react";
function SvgAddress(props) {
  return <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M24 2C15.163 2 8 9.163 8 18c0 10.5 14.1 26.7 14.7 27.4.7.8 1.9.8 2.6 0C25.9 44.7 40 28.5 40 18c0-8.837-7.163-16-16-16zm0 24a8 8 0 110-16 8 8 0 010 16z" fill="#A9A9A9" fillRule="evenodd" /></svg>;
}
export default SvgAddress;